
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/jobs/[[...id]]",
      function () {
        return require("private-next-pages/jobs/[[...id]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/jobs/[[...id]]"])
      });
    }
  